/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { faker } from '@faker-js/faker/locale/en';
import { ENTITY_TYPES } from '../../../constants/Repository.constants';
import { JobContextRecord } from '../JobContext';

export const createMockJobContextRecord = (partialRecord: Partial<JobContextRecord> = {}): JobContextRecord => {
  const tenant = faker.string.uuid();
  const contextName = faker.lorem.word();
  const numOfEnvVars = faker.number.int({ max: 5, min: 1 });
  const environment: Record<string, string> = {};
  const description = faker.lorem.words();
  for (let i = 0; i < numOfEnvVars; i++) {
    const key = faker.lorem.word(); // Generate a random key
    const value = faker.lorem.word(); // Generate a random value
    environment[key] = value;
  }
  return {
    environment,
    description,
    pk: `${ENTITY_TYPES.context}~${tenant}`,
    sk: contextName,
    ...partialRecord,
  };
};

export const createMockJobContextRecords = (size?: number): Array<JobContextRecord> => {
  const randomSize = size ?? faker.number.int({ max: 3, min: 1 });
  return Array.from({ length: randomSize }).map(() => createMockJobContextRecord());
};
